var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.76 9h2l-2.2 10h-2l2.2-10Zm1.68-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }